import validate from './schema/validate';

export const prepareValue = (newVals, containerName, iState, field, schema, value) => {
  if (!iState.hasOwnProperty(field)) throw `Container ${containerName} has no internal state field: ${field}`;
  newVals[field] = validate(`${containerName}:${field}`, schema, value);
};

export default (iState, internalStateSchemas, containerName, setInternalState, fieldOrObject, val) => {
  const newVals = {};
  if (typeof fieldOrObject === 'object') {
    Object.keys(fieldOrObject).forEach((k) => {
      prepareValue(newVals, containerName, iState, k, internalStateSchemas[k], fieldOrObject[k]);
    });
  } else {
    prepareValue(newVals, containerName, iState, fieldOrObject, internalStateSchemas[fieldOrObject], val);
  }
  setInternalState((prevState) => ({ ...prevState, ...newVals }));
};
